import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { FinancesIntro } from "web_myplann/Finances/Pages/FinancesIntro";
import { FinancesIntroV2 } from "web_myplann/Finances/Pages/FinancesIntroV2";

export const FinancesIntroPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <FinancesIntroV2 /> : <FinancesIntro />;
};
